<crm-auto-complete
  [(value)]="selectedDeal"
  (valueChange)="selectedDealChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [suggestions]="deals"
  [field]="field"
  [virtualScroll]="true"
  [virtualScrollItemSize]="75"
  [inputStyleClass]="inputStyleClass"
  dataKey="id"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [showClear]="showClear"
  [isError]="isError"
  (completeMethod)="customSearch ? dealSearch.emit($event.query) : searchDeal($event.query)">
  <ng-template
    let-deal="item"
    #itemTemplate>
    <ng-container *ngIf="toDeal(deal) as deal">
      <div class="flex justify-content-between align-items-center white-space-normal gap-2">
        <div>
          <p
            *ngIf="deal.name?.length > 40; else shortNameTemplate"
            class="font-bold"
            [pTooltip]="deal.name"
            tooltipPosition="top">
            {{ deal.name | truncate: 40 }}
          </p>
          <p class="font-medium">{{ deal.contragent?.name }}</p>
          <p class="font-bold text-green-500">{{ deal.amount | number: '.0-0' }}</p>
        </div>
        <div class="white-space-nowrap">
          <crm-status-label
            *ngIf="deal.status"
            [name]="deal.status.name"
            [color]="deal.status.color"></crm-status-label>
        </div>
      </div>

      <ng-template #shortNameTemplate>
        <p class="font-bold">
          {{ deal.name | truncate: 40 }}
        </p>
      </ng-template>
    </ng-container>
  </ng-template>
</crm-auto-complete>
